import { Component, ElementRef, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AppMenu } from './app.menu';
import { CuiToggleSwitchComponent } from '@idealink-material/ui-core';
import { FormsModule } from '@angular/forms';
import { LayoutService } from '@/layout/service/layout.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [AppMenu, CuiToggleSwitchComponent, FormsModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ` <div class="layout-sidebar">
        <div class="flex flex-col items-center justify-center h-screen">
            <div class="menu-container">
                <div app-menu></div>
            </div>
            <div class="sidebar-bottom">
                <div class="sidebar-divider"></div>
                <!-- Light Mode Toggle -->
                <div class="flex flex-col justify-center items-center gap-3">
                    <p-toggle-switch [(ngModel)]="checked" />
                    <span class="toggle-label">{{ (checked ? 'theme.dark' : 'theme.light') | translate }}</span>
                </div>
            </div>
        </div>
    </div>`
})
export class AppSidebar {
    el = inject(ElementRef);
    @ViewChild(AppMenu) appMenu!: AppMenu;
    layoutService = inject(LayoutService);

    get checked(): boolean {
        return this.layoutService.isDarkTheme();
    }

    set checked(value: boolean) {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: value }));
    }
}
